import { render } from "./hotel_card.vue?vue&type=template&id=49614e02"
import script from "./hotel_card.vue?vue&type=script&lang=js"
export * from "./hotel_card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__